import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { LMapService } from '../services';


@Component({
    selector: 'l-zoom',
    styles: [
        `
        :host {
            display: inline-block;
        }
        .btn-group-vertical {
            width: 2rem;
        }
        .btn {
            font-weight: bold;
            padding: 0.5rem 0;
        }
        `,
    ],
    template: `
        <div class="btn-group-vertical print-hidden shadow" tooltip="Map Zoom Control" tooltipPlacement="right">
            <button (click)="zoomIn()" [disabled]="isZoomInDisabled()" class="btn btn-secondary">
                +
            </button>
            @if (showLevel()) {
                <div class="btn btn-secondary">{{ roundedZoomLevel() }}</div>
            }
            <button (click)="zoomOut()" [disabled]="isZoomOutDisabled()" class="btn btn-secondary">
                &minus;
            </button>
        </div>
    `,
})
export class ZoomComponent {

    showLevel = input(false);

    zoomLevel = signal(0);

    roundedZoomLevel = computed(() => (Math.floor(this.zoomLevel() * 10) / 10).toFixed(1));

    isZoomInDisabled = signal(true);

    isZoomOutDisabled = signal(true);

    private mapService = inject(LMapService);

    constructor() {
        effect(() => {
            const zoom = this.mapService.zoom();
            const minZoom = this.mapService.minZoom();
            const maxZoom = this.mapService.maxZoom();
            this.zoomLevel.set(zoom);
            this.isZoomInDisabled.set(zoom >= maxZoom);
            this.isZoomOutDisabled.set(zoom <= minZoom);
        });
    }

    zoomIn() {
        if (!this.isZoomInDisabled()) {
            this.mapService.setZoom(Math.floor(this.zoomLevel()) + 1);
        }
        this.mapService.getMap().getContainer().focus();
    }

    zoomOut() {
        if (!this.isZoomOutDisabled()) {
            this.mapService.setZoom(Math.ceil(this.zoomLevel()) - 1);
        }
        this.mapService.getMap().getContainer().focus();
    }
}
